var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9C20 10.1 19.1 11 18 11C16.9 11 16 10.1 16 9C16 7.9 16.9 7 18 7C19.1 7 20 7.9 20 9Z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15C20 16.1 19.1 17 18 17C16.9 17 16 16.1 16 15C16 13.9 16.9 13 18 13C19.1 13 20 13.9 20 15Z",
    fill: "#A1A5B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 10.1 13.1 11 12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9Z",
    fill: "#A1A5B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 16.1 13.1 17 12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15Z",
    fill: "#A1A5B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9C8 10.1 7.1 11 6 11C4.9 11 4 10.1 4 9C4 7.9 4.9 7 6 7C7.1 7 8 7.9 8 9Z",
    fill: "#A1A5B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C8 16.1 7.1 17 6 17C4.9 17 4 16.1 4 15C4 13.9 4.9 13 6 13C7.1 13 8 13.9 8 15Z",
    fill: "#A1A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.9654f9a7e36ef16f0e3a5f0c30392805.svg";
export { ForwardRef as ReactComponent };